/**
 * AI助手全局层级（悬浮球 / 面板）。
 *
 * 悬浮球置顶：2147483647 是浏览器能表达的 z-index 上限（int32 上限；实测 Chrome 会把更大的值一律钳到该值），
 * 仓库里「进度球 99999999999999」「g-drag-canvas 9999999999999999」「Loading 10000000000000」等超大值
 * 实际渲染值同样是它；同层级时由 DOM 顺序决胜，而助手组件挂在 #home 末尾，因此稳定压在这些全局悬浮物之上。
 * 面板只比悬浮球低一级，始终位于悬浮球之下、其余界面元素之上。
 */
export const ASSISTANT_BUBBLE_Z_INDEX = 2147483647

export const ASSISTANT_PANEL_Z_INDEX = ASSISTANT_BUBBLE_Z_INDEX - 1
